/**
 * @public
 * @remarks
 * Enum of reactions
 */
export var ReactionCode;
(function (ReactionCode) {
    /** like */
    ReactionCode["LIKE"] = ":like:";
    ReactionCode["WOW"] = ":wow:";
    ReactionCode["SAD"] = ":sad:";
    ReactionCode["HAHA"] = ":haha:";
    ReactionCode["ANGRY"] = ":angry:";
    ReactionCode["CLAP"] = ":clap:";
    ReactionCode["THUMBS_UP"] = ":thumbs_up:";
    ReactionCode["THINKING"] = ":thinking:";
    ReactionCode["LOVE"] = ":love:";
    ReactionCode["SMILE"] = ":smile:";
})(ReactionCode || (ReactionCode = {}));
//# sourceMappingURL=comments-reaction-types.js.map